import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
    this.setState({ error, info });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6">
          <div className="max-w-2xl bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-xl font-bold mb-2">Something went wrong</h2>
            <p className="text-sm text-gray-600 mb-4">A runtime error occurred while rendering the page. Details are shown below.</p>
            <pre className="text-xs whitespace-pre-wrap bg-gray-50 p-3 rounded text-red-700">{this.state.error && this.state.error.toString()}</pre>
            <div className="mt-4 flex gap-3">
              <button className="btn-cta" onClick={() => window.location.reload()}>Reload</button>
              <button className="btn-ghost-dark" onClick={() => { this.setState({ hasError: false, error: null, info: null }); }}>Dismiss</button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
